<script setup>
  import { computed, useSlots } from 'vue';

  import ToggleInput from "@/components/controls/ToggleInput.vue";
  import Icon from "@/components/icons/Icon.vue";

  defineEmits(['input:change']);

  const model = defineModel();

  const props = defineProps({
    id: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: false
    },
    value: {
      type: [String, Number, Array, Object, Boolean],
      required: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    inputType: {
      type: String,
      default: 'checkbox'
    },
    trueValue: {
      type: [String, Number],
      validator(value, props) {       
        return props.inputType === 'checkbox' && props.falseValue && value;
      }
    },
    falseValue: {
      type: [String, Number],
      validator(value, props) {       
        return props.inputType === 'checkbox' && props.trueValue && value;
      }
    },
    iconName: {
      type: String,
      required: false
    },
    hideLabelText: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'medium'
    },
    color: {
      type: String,
      required: false
    },
    surface: {
      type: Number,
      required: false
    }
  });  

  const slots = useSlots();

  const hasIcon = computed(() => !!slots.iconName);
</script>

<template>
  <div class="jwx-toggle">
    <ToggleInput
      @input:change="$emit('input:change', $event)"
      :id="props.id"
      :name="props.name"
      :value="props.value"
      :disabled="props.disabled"
      :inputType="props.inputType"
      :trueValue="props.trueValue"
      :falseValue="props.falseValue"
      v-model="model"
    />
    <label
      :for="props.id"
      class="jwx-toggle__label" 
      :data-icon="hasIcon"
      :data-label-text-hidden="props.hideLabelText"
      :data-size="props.size"
    >
      <div 
        class="jwx-toggle__label-icon" 
      >
        <Icon v-if="iconName" :name="iconName" />
      </div>
      <span
        class="jwx-toggle__label-text"
        :class="{'sr-only': props.hideLabelText}"
      >
        <slot></slot>
      </span>
      <div
        class="jwx-toggle__switch"
        :style="`--jwx-toggle-switch-handle-color-active: ${props.color};`"
        :data-surface="props.surface"
        :data-use-color="!!props.color"
      ></div>
    </label>
  </div>
</template>